import React, { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { X } from 'lucide-react';
import AvailabilityStrip from './AvailabilityStrip';

/*
  /bookings "See current wait times" (round 6b).
  The link still points at the homepage strip (/#availability), so it works
  before the page loads and for anyone without JavaScript. Once the page has
  loaded, a click opens this pop-up instead, showing the SAME strip component
  and availability.json data as the homepage. Nothing is in the saved HTML:
  the pop-up only exists while it is open.

  Radix Dialog gives: Escape closes, a tap outside closes, focus stays inside
  while open and goes back to the link on close, and screen readers hear it
  as a dialog named by its title. Styling reuses the page's own modal classes
  (Bookings.css), so it looks like the Fees and Treatment Plan pop-ups.
*/
const WaitTimesDialog = () => {
  const [open, setOpen] = useState(false);

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      {/* Trigger: adds the dialog's aria attributes and gets focus back on close.
          Our click handler stops the jump to the homepage and opens the pop-up. */}
      <Dialog.Trigger asChild>
        <a
          href="/#availability"
          className="inline-link"
          onClick={(e) => { e.preventDefault(); setOpen(true); }}
        >
          See current wait times
        </a>
      </Dialog.Trigger>
      {/* No portal: rendered inside .page-bookings so it picks up the page's modal look */}
      <Dialog.Overlay className="modal-overlay" data-testid="wait-times-overlay">
        <Dialog.Content
          className="modal-content wait-times-dialog"
          aria-describedby={undefined}
          data-testid="wait-times-dialog"
        >
          <div className="modal-header">
            <Dialog.Title asChild>
              <h2 className="heading-2">Current wait times</h2>
            </Dialog.Title>
            <Dialog.Close className="modal-close" aria-label="Close">
              <X size={24} aria-hidden="true" />
            </Dialog.Close>
          </div>
          <div className="modal-body">
            <AvailabilityStrip anchor={false} />
          </div>
        </Dialog.Content>
      </Dialog.Overlay>
    </Dialog.Root>
  );
};

export default WaitTimesDialog;
